import type { TaskDrawerScope } from '../model/use-task-drawer-store';
import { ListChecks } from 'lucide-react';
import { Button, Tooltip } from '@/shared/ui';
import { useTaskDrawerStore } from '../model/use-task-drawer-store';
import { TaskCountBadge } from './task-count-badge';
import css from './task-drawer-trigger.module.scss';

type TaskDrawerTriggerProps = {
  /** Pre-fill the drawer scope (e.g. `{ itineraryId }`). Defaults to no scope. */
  scope?: TaskDrawerScope;
  label?: string;
  className?: string;
};

/**
 * Topbar / itinerary-header trigger. Clicking opens the drawer with the
 * provided scope (defaults to "my tasks" view when no scope is passed —
 * see `task-drawer.tsx` for the resolution logic).
 */
export const TaskDrawerTrigger = ({
  scope,
  label = 'Open tasks',
  className,
}: TaskDrawerTriggerProps) => {
  const openDrawer = useTaskDrawerStore((s) => s.openDrawer);
  return (
    <Tooltip content={label} position="bottom">
      <div className={css.root}>
        <Button
          aria-label={label}
          className={className}
          icon={<ListChecks className={css.icon} />}
          onClick={() => openDrawer(scope)}
          size="icon"
          variant="ghost"
        />
        <span className={css.badgeAnchor}>
          <TaskCountBadge />
        </span>
      </div>
    </Tooltip>
  );
};
